class ThemeMode {
  constructor() {
    // Primero intentamos obtener la preferencia guardada
    this.theme = localStorage.getItem('theme');
    
    // Si no hay preferencia guardada, usamos la preferencia del sistema
    if (!this.theme) {
      this.theme = this.getSystemPreference();
    }
    
    this.toggleButton = document.querySelector('[data-theme-toggle]');
    this.init();
    
    // Escuchar cambios en la preferencia del sistema
    this.watchSystemPreference();
  }

  getSystemPreference() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  watchSystemPreference() {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (!localStorage.getItem('theme')) { // Solo si no hay preferencia manual
        this.theme = e.matches ? 'dark' : 'light';
        this.updateTheme();
      }
    });
  }

  init() {
    this.updateTheme();
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', () => this.toggleTheme());
    }
  }

  updateTheme() {
    document.documentElement.setAttribute('data-theme', this.theme);
  }

  toggleTheme() {
    this.theme = this.theme === 'light' ? 'dark' : 'light';
    this.updateTheme();
    localStorage.setItem('theme', this.theme);
  }
}

// Initialize theme mode
window.addEventListener('DOMContentLoaded', () => {
  new ThemeMode();
});